import React, { useState, useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { Formik } from 'formik';
import styled from 'styled-components';
import { helpSchema } from './schemas';
import DataState from '../DataState';
import AuthContext from '../../contexts/AuthContext';
import { useMutation, useLazyQuery } from '@apollo/client';
import { REQUEST_ASSISTANCE } from './queries';
import { formatAuthErrors } from '../../utils/errorHelpers';
import axios from 'axios';
import secrets from '../../secrets';
import jsPDF from 'jspdf';
import { InstructionsPDF } from './InstructionsPDF';
import {
  titleColor,
} from '../../styles/colors';

import {
  Label,
  Button,
  CancelButton,
  Container,
  Input,
  ErrorMessage,
  TextArea,
  TitleContainer,
  Title,
  InstructionsTitle,
  Text
} from './elements';

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 0px;
  margin-bottom: 20px;
`;

const inputBackground = {
  backgroundColor: '#EFEFEF',
  border: 'none'
}

const Instructions = () => {
  const auth = useContext(AuthContext);
  const [fileLoading, setFileLoading] = useState(false);

  const download = () => {
    InstructionsPDF()
  }

  const print = () => {
   let mywindow = window.open('', 'PRINT', 'height=650,width=900,top=100,left=150');

    mywindow.document.write(`<html><head><title>Fly Louie FBO Portal Instructions</title>`);
    mywindow.document.write('</head><body >');
    mywindow.document.write('<center><div style="font-weight: bold; font-size: 2rem">Fly Louie FBO Portal Instructions</div></center>');
    mywindow.document.write(document.getElementById('instructions').innerHTML);
    mywindow.document.write('</body></html>');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    mywindow.close();

    return true;
  }

  return (
    <>
      <Container>
        <TitleContainer>
          <Title>
            Fly Louie FBO Portal Instructions
          </Title>
        </TitleContainer>
        <ButtonRow>
          <div className="col-md-2">
            <Button
              type="button"
              onClick={() => print()}
            >
              Print
            </Button>
          </div>
          <div className="col-md-1"/>
          <div className="col-md-2">
            <Button
              type="button"
              onClick={() => download()}
            >
              Download
            </Button>
          </div>
        </ButtonRow>
        <div id="instructions" style={{width: '100%'}}>
          <Title>Tail Number or Operator Lookup</Title>
          <Text>
            This page allows users to determine whether an aircraft is a part
            of the Fly Louie Fuel Program.
            <br /><br />
            Enter any tail number in the search field.  If the tail number is
            found to be in the Alliance, the user will see a table with the
            Operator Name, Avfuel account name, and all associated Avfuel
            “Bill-To” codes. If an aircraft shows multiple accounts, the FBO
            must verify the appropriate account with the crew or dispatcher.
            <br /><br />
            If you have any problems using this tool, simply click the link for
            immediate assistance.  You will be asked for some basic information,
            and someone from Fly Louie will then call you right away.
          </Text>
          <br />
          <Title>Add New FBO Portal Users</Title>
          <Text>
            This page allows users to add new FBO Portal Users.  Enter the
            requested information and click "submit".  You will need to select
            if the new User should be an "Admin" User or a "Normal" User.
            Admin Users are also authorized to view historical activity
            statements from Fly Louie and a full list of Users on the account.
            <br /><br />
            After clicking "Submit", an email will be sent to the new User
            prompting them to set up their account.
          </Text>
          <br />
          <Title>User List</Title>
          <Text>
            This page provides a list of all users on the account.  You may
            edit or delete any existing User by clicking the applicable link.
          </Text>
          <br />
          <Title>Statements</Title>
          <Text>
            This page provides access to the FBO's historical activity
            statements from Fly Louie for the past 12 months.  You may view or
            print any statement by selecting "View PDF".
          </Text>
          <br />
        </div>
      </Container>
    </>
  )
}

export default Instructions